// import React, {Component} from 'react';
// import { Button, Intent, Spinner , Navbar} from "@blueprintjs/core";
 import React from "react";

import {withFirebase} from '../Firebase';


// class SignOutButton extends Component{
//     constructor(props){
//         super(props);

//     }
//     // componentDidMount() {
//     //     this.props.firebase.doSignOut;
//     // }

//     render() {
//         return (
//             ({firebase}) => (<button onClick={firebase.doSignOut}className="bp3-button bp3-minimal bp3-icon-cog"></button>)
//         );
//     }

// }
const SignOutButton = ({ firebase }) => (
    <button className="bp3-button bp3-minimal bp3-icon-cog" type="button" onClick={firebase.doSignOut}>
    </button> );
    



export default withFirebase(SignOutButton);